import { getAPIDomain } from "./config.js";
import { apiCall } from "../utils/apiUtils.js";
export const loginUser = async (email, password) => {
  try {
    const res = await fetch(`${getAPIDomain()}/login/user`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (res.ok && data.success && data.token) {
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("role", data.user.role);
      // console.log("Login successful, token stored.",data);
      return { success: true, message: data.message, token: data.token };
    }
    return { success: false, message: data.message || "Authentication failed" };
  } catch (err) {
    console.error("Login Failed!", err);
    return {
      success: false,
      message: "Something went wrong. Please try again.",
    };
  }
};

export const fetchPatientByUserId = async (userId) => {
  const result = await apiCall(
    `${getAPIDomain()}/api/users/by-user-id/${userId}`,
    {
      method: "GET",
    }
  );
  if (result.success) {
    return result.data;
  } else {
    console.error("Fetching User Failed!", result.message);
  }
};

export const fetchStudies = async () => {
  const result = await apiCall(`${getAPIDomain()}/api/studies`, {
    method: "GET",
  });

  if (result.success) {
    return result.data;
  } else {
    console.error("Fetching Studies Failed!", result.message);
    return {
      success: false,
      message: result.message,
    };
  }
};

export const createStudy = async (studyData) => {
  const name = studyData.name;
  const description = studyData.description;
  const createdAt = studyData.createdAt;
  const startDate = studyData.startDate;
  const closeDate = studyData.closeDate;

  // Normalize empty strings to null so MySQL DATE columns don't receive ''
  const payload = {
    name,
    description,
    createdAt: createdAt && createdAt.trim() !== "" ? createdAt : null,
    startDate: startDate && startDate.trim() !== "" ? startDate : null,
    closeDate: closeDate && closeDate.trim() !== "" ? closeDate : null,
  };

  const result = await apiCall(`${getAPIDomain()}/api/studies`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  if (result.success) {
    return result.data;
  } else {
    console.error("Creating Study Failed!", result.message);
    return {
      success: false,
      message: result.message,
    };
  }
};

export const updateStudy = async (study) => {
  // Normalize empty date strings to null to satisfy MySQL DATE columns
  const payload = {
    ...study,
    createdAt:
      study.createdAt && String(study.createdAt).trim() !== ""
        ? study.createdAt
        : null,
    startDate:
      study.startDate && String(study.startDate).trim() !== ""
        ? study.startDate
        : null,
    closeDate:
      study.closeDate && String(study.closeDate).trim() !== ""
        ? study.closeDate
        : null,
  };

  const result = await apiCall(`${getAPIDomain()}/api/studies`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

  if (result.success) {
    return result.data;
  } else {
    console.error("Updating Study Failed!", result.message);
    return {
      success: false,
      message: result.message,
    };
  }
};

export const fetchStudyById = async (id) => {
  const result = await apiCall(`${getAPIDomain()}/api/studies/${id}`, {
    method: "GET",
  });

  if (result.success) {
    return result.data;
  } else {
    console.error("Fetching Study Failed!", result.message);
    return null;
  }
};

export const userByStudy = async (id) => {
  const result = await apiCall(`${getAPIDomain()}/api/users/${id}`, {
    method: "GET",
  });

  if (result.success) {
    return result.data;
  } else {
    console.error("Fetching User Failed!", result.message);
    return null;
  }
};
export const fetchActivities = async (id) => {
  const result = await apiCall(`${getAPIDomain()}/api/users/activites/${id}`, {
    method: "GET",
  });

  if (result.success) {
    return result.data;
  } else {
    console.error("Fetching Activities Failed!", result.message);
    return null;
  }
};
export const updateActivities = async (id, data) => {
  const result = await apiCall(`${getAPIDomain()}/api/users/activites/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (result.success) {
    return result.data;
  } else {
    console.error("Updating Activities Failed!", result.message);
    return null;
  }
};

export const fetchActivitySummaries = async (userId) => {
  const result = await apiCall(`${getAPIDomain()}/user-activity/user/${userId}`, {
    method: "GET",
  });

  if (result.success) {
    return result.data.data || [];
  } else {
    console.error("Fetching Activity Summaries Failed!", result.message);
    return [];
  }
};

export const updateActivitySummaryDate = async (userId, date, data) => {
  const result = await apiCall(`${getAPIDomain()}/user-activity/user/${userId}/date/${date}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (result.success) {
    return result.data;
  } else {
    console.error("Updating Activity Summary Failed!", result.message);
    return null;
  }
};

export const addAnalysisAuditLog = async (logData) => {
  const result = await apiCall(`${getAPIDomain()}/user-activity/audit-logs`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(logData),
  });
  if (result.success) {
    return result.data;
  } else {
    console.error("Adding Analysis Audit Log Failed!", result.message);
    return null;
  }
};

export const fetchAnalysisAuditLogs = async (userId) => {
  const result = await apiCall(`${getAPIDomain()}/user-activity/audit-logs/${userId}`, {
    method: "GET",
  });
  if (result.success) {
    return result.data.data || [];
  } else {
    console.error("Fetching Analysis Audit Logs Failed!", result.message);
    return [];
  }
};

export const saveBaseline = async (baselineData) => {
  const result = await apiCall(`${getAPIDomain()}/user-activity/baseline`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(baselineData),
  });
  if (result.success) {
    return result.data;
  } else {
    console.error("Saving Baseline Failed!", result.message);
    return null;
  }
};

export const fetchBaseline = async (userId) => {
  const result = await apiCall(`${getAPIDomain()}/user-activity/baseline/${userId}`, {
    method: "GET",
  });
  if (result.success) {
    return result.data.data;
  } else {
    // 404 is expected if no baseline exists yet
    return null;
  }
};

export const renameBaseline = async (recordId, newName, changedBy, changedByEmail) => {
  const result = await apiCall(`${getAPIDomain()}/user-activity/baseline/${recordId}/rename`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ newName, changedBy, changedByEmail }),
  });
  if (result.success) {
    return result.data;
  } else {
    console.error("Renaming Baseline Failed!", result.message);
    return null;
  }
};

export const deleteBaseline = async (recordId) => {
  const result = await apiCall(`${getAPIDomain()}/user-activity/baseline/${recordId}`, {
    method: "DELETE",
  });
  if (result.success) {
    return result.data;
  } else {
    console.error("Deleting Baseline Failed!", result.message);
    return null;
  }
};
export const activateStudy = async (id) => {
  const result = await apiCall(`${getAPIDomain()}/api/studies/${id}/activate`, {
    method: "POST",
  });

  if (result.success) {
    return result.data;
  } else {
    console.error("Activating Study Failed!", result.message);
    return {
      success: false,
      message: result.message,
    };
  }
};

export const addAuditLogs = async (auditData) => {
  const result = await apiCall(`${getAPIDomain()}/api/audit-logs/add`, {
    method: "POST",
    body: JSON.stringify(auditData),
  });

  if (result.success) {
    return result.data;
  } else {
    console.error("Activating Study Failed!", result.message);
    return {
      success: false,
      message: result.message,
    };
  }
};


export const fetchAdminLogs = async (page = 1, limit = 50, userId) => {
  try {
    const url =
      `${getAPIDomain()}/api/admin/logs?page=${page}&limit=${limit}` +
      (userId ? `&user_id=${encodeURIComponent(userId)}` : "");
    // (userId ? `&user_id=${userId}` : "");
    const result = await apiCall(url, { method: "GET" });
    if (result.success === true) {
      return result.data.logs;
    } else {
      console.error("Fetching Logs Failed!", result.message);
      return [];
    }
  } catch (err) {
    console.error("Error fetching logs:", err);
    return [];
  }
};
export const fetchClinics = async () => {
  const result = await apiCall(`${getAPIDomain()}/api/clinics`, {
    method: "GET",
  });

  if (result.success) {
    return result.data;
  } else {
    console.error("Fetching Clinics Failed!", result.message);
    return {
      success: false,
      message: result.message,
    };
  }
};
export const createClinic = async (clinicData) => {
  const result = await apiCall(`${getAPIDomain()}/api/clinics`, {
    method: "POST",
    body: JSON.stringify(clinicData),
  });

  if (!result.success) {
    console.error("Creating Clinic Failed!", result.message);
    throw new Error(result.message);
  }

  return result.data;
};

export const updateClinicAPI = async (clinic) => {
  const clinic_id = clinic.clinic_id;
  const result = await apiCall(`${getAPIDomain()}/api/clinics/${clinic_id}`, {
    method: "PUT",
    body: JSON.stringify(clinic),
  });
  if (result.success) {
    return result.data;
  } else {
    console.error("Updating Clinic Failed!", result.message);
    return {
      success: false,
      message: result.message,
    };
  } 
};
export const deleteClinicAPI = async (clinicId) => {
  const result = await apiCall(`${getAPIDomain()}/api/clinics/${clinicId}`, {
    method: "DELETE",
  });
  if (!result.success) {
    throw new Error(result.message || "Failed to delete clinic");
  }
  return result;
};
